import { createRouter, createWebHistory } from "vue-router";
// 这个是布局组件，如果我们项目不需要使用内置布局则可以删除掉
import LayoutConsole from "@/Layout/LayoutConsole.vue";
import LayoutEmpty from "@/Layout/LayoutEmpty.vue";
import LayoutHome from "@/Layout/LayoutHome.vue";
// 路由模块
import errorPages from "./Modules/ErrorPages";

// 固定路由，一般不会根据权限或者用户信息改变的路由
export const constantRoutes = [
  {
    path: '/',
    name: 'mainpage',
    redirect: '/mainpageindex',
    component: LayoutEmpty,
    children: [
      {
        path: 'mainpageindex',
        name: 'mainpageindex',
        component: () => import('@/Views/MainPage.vue')
      }
    ],
    hidden: true
  },
  {
    path: '/home',
    component: LayoutHome,
    children: [
      // {
      //   path: "",
      //   name: "Introduce",
      //   component: () => import("@/Views/Home/Introduce.vue"),
      //   hidden: true,
      // },
      {
        path: "doc",
        name: "Doc",
        component: () => import("@/Views/Home/Doc.vue"),
        hidden: true,
      },
    ],
    hidden: true
  },
  {
    path: '/d',
    component: LayoutHome,
    children: [
      {
        path: "",
        component: () => import("@/Views/Home/Download.vue"),
        hidden: true,
      },
      {
        path: ":uri",
        name: "Download",
        component: () => import("@/Views/Home/Download.vue"),
        hidden: true,
      },
    ],
    hidden: true
  },
  {
    path: '/activity',
    component: LayoutHome,
    children: [
      {
        path: "",
        component: () => import("@/Views/Home/ActivityShare.vue"),
        hidden: true,
      },
      {
        path: ":uri",
        name: "ActivityShare",
        component: () => import("@/Views/Home/ActivityShare.vue"),
        hidden: true,
      },
    ],
    hidden: true
  },
  {
    path: '/file',
    component: LayoutHome,
    children: [
      {
        path: "",
        component: () => import("@/Views/Home/FileShare.vue"),
        hidden: true,
      },
      {
        path: ":uri",
        name: "FileShare",
        component: () => import("@/Views/Home/FileShare.vue"),
        hidden: true,
      },
    ],
    hidden: true
  },
  errorPages,
];

// 动态路由， 根据获取到的用户权限或者配置改变的路由
export const asyncRoutes = [
  {
    path: '/console',
    component: LayoutConsole,
    hiddenSelfOnly: true,
    children: [
      // admin
      {
        path: "",
        name: "Overview",
        meta: {
          title: "项目概况",
          icon: "tako-home-icon",
          justAdmin: true
        },
        component: () => import("@/Views/Console/Overview.vue"),
      },
      {
        path: "apps",
        meta: {
          title: "应用管理",
          icon: "tako-apps-icon",
          justAdmin: true
        },
        component: LayoutEmpty,
        children: [
          {
            path: "",
            name: "Apps",
            meta: {
              title: "应用列表",
              icon: "",
              justAdmin: true
            },
            component: () => import("@/Views/Console/Apps.vue"),
          },
          {
            path: "log",
            name: "AppsLog",
            meta: {
              title: "应用日志",
              icon: "",
              justAdmin: true
            },
            component: () => import("@/Views/Console/AppLog.vue"),
          },
          {
            path: "storage",
            name: "AppsStorage",
            meta: {
              title: "储存管理",
              icon: "",
              justAdmin: true
            },
            component: () => import("@/Views/Console/StorageManagement.vue"),
          }
        ]
      },
      {
        path: "activities",
        name: "ProjectActivities",
        meta: {
          title: "活动管理",
          icon: "tako-activity-icon",
          justAdmin: true
        },
        component: () => import("@/Views/Console/Activities.vue"),
      },
      {
        path: "analysis",
        name: "ProjectAnalysis",
        meta: {
          title: "数据统计",
          icon: "tako-analysis-icon",
          justAdmin: true
        },
        component: () => import("@/Views/Console/ProjectAnalysis.vue"),
      },
      {
        path: "users",
        name: "ProjectUsers",
        meta: {
          title: "人员管理",
          icon: "tako-users-icon",
          justAdmin: true
        },
        component: () => import("@/Views/Console/Users.vue"),
      },
      // tester
      {
        path: "test",
        name: "Test",
        meta: {
          title: "我的测试",
          icon: "tako-mytest-icon",
          justTester: true
        },
        component: () => import("@/Views/Console/Test.vue"),
      },
      // public
      {
        path: "package-analysis",
        name: "PackageAnalysis",
        meta: {
          title: "包体分析",
          icon: "tako-analysis-icon",
        },
        component: () => import("@/Views/Console/PackageAnalysis.vue"),
      },
      {
        path: "file-distribution",
        name: "FileDistribution",
        meta: {
          title: "文件分发",
          icon: "tako-filedistribution-icon",
        },
        component: () => import("@/Views/Console/FileDistribution.vue"),
      },
    ],
  },
  {
    path: '/admin',
    meta: {
      title: "Tako管理",
      icon: "icon-jibenpeizhi",
      justSuperAdmin: true
    },
    component: LayoutConsole,
    children: [
      {
        path: "",
        meta: {
          justSuperAdmin: true,
        },
        hidden: true,
        redirect: { name: 'AdminProjects' }
      },
      {
        path: "projects",
        name: "AdminProjects",
        meta: {
          title: "项目管理",
          icon: "icon-menu",
          justSuperAdmin: true
        },
        component: () => import("@/Views/Admin/Projects.vue"),
      },
      {
        path: "analysis",
        name: "TakoAnalysis",
        meta: {
          title: "系统状态",
          icon: "icon-tubiao",
          justSuperAdmin: true,
          justAdmin: true
        },
        component: () => import("@/Views/Admin/AnalysisTako.vue"),
      },
      {
        path: "projects-log",
        name: "AdminProjectsLog",
        meta: {
          title: "应用日志",
          icon: "icon-xiangqing",
          justSuperAdmin: true,
        },
        component: () => import("@/Views/Admin/ProjectLogs.vue"),
      },
      {
        path: "certificate",
        name: "AdminCertificate",
        meta: {
          title: "证书管理",
          icon: "icon-zhengshu",
          justSuperAdmin: true,
        },
        component: () => import("@/Views/Admin/Certificate.vue"),
      },
    ],
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: [...constantRoutes, ...asyncRoutes],
});

export default router;
